export class BannerPromo {
    constructor(public id: string, public name: string, public path: string, public path_apps: string, public is_active: boolean){}
}